import React from 'react';
import { Skeleton } from '@frontend/shadcn/components/ui/skeleton';
import { GlobeIcon, CircleInfoIcon } from '@revfluence/fresh-icons/solid/esm';
import type { AudienceSummarySectionProps } from './hooks';

export const AudienceSummarySection: React.FC<AudienceSummarySectionProps> = ({
  isLoading,
  data
}) => {
  if (isLoading) {
    return (
      <div className="flex flex-col gap-3">
        <div className="flex items-center gap-2">
          <Skeleton className="h-6 w-6 rounded-lg" />
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-4 w-4 rounded-full" />
        </div>
        <div className="flex gap-3">
          <div className="flex-1 p-3 rounded-xl border border-grey-3">
            <Skeleton className="h-3 w-24 mb-2" />
            <Skeleton className="h-4 w-16" />
          </div>
          <div className="flex-1 p-3 rounded-xl border border-grey-3">
            <Skeleton className="h-3 w-24 mb-2" />
            <Skeleton className="h-4 w-12" />
          </div>
          <div className="flex-1 p-3 rounded-xl border border-grey-3">
            <Skeleton className="h-3 w-32 mb-2" />
            <Skeleton className="h-4 w-20" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col">
        <div className="flex items-center gap-2">
          <div className="w-6 h-6 bg-teal-4 rounded-lg flex justify-center items-center">
            <GlobeIcon className="w-3 h-3 text-white" />
          </div>
          <div className="text-grey-6 text-sm font-medium leading-normal">Audience Summary</div>
          <div className="flex items-start">
            <CircleInfoIcon className="w-4 h-4 text-grey-4" />
          </div>
        </div>
      </div>

      <div className="flex gap-3">
        <div className="flex-1 p-3 rounded-xl border border-grey-3 flex flex-col">
          <div className="flex flex-col gap-2">
            <div className="flex justify-between items-center">
              <div className="flex-1 text-grey-6 text-xs font-medium leading-tight">Engagements per Post</div>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <div className="text-grey-5 text-base font-normal leading-normal">{data.engagementsPerPost}</div>
          </div>
        </div>

        <div className="flex-1 p-3 rounded-xl border border-grey-3 flex flex-col">
          <div className="flex flex-col gap-2">
            <div className="flex justify-between items-center">
              <div className="flex-1 text-grey-6 text-xs font-medium leading-tight">Impressions per Post</div>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <div className="text-grey-5 text-base font-normal leading-normal">{data.impressionsPerPost}</div>
          </div>
        </div>

        <div className="flex-1 p-3 rounded-xl border border-grey-3 flex flex-col">
          <div className="flex flex-col gap-2">
            <div className="flex justify-between items-center">
              <div className="flex-1 text-grey-6 text-xs font-medium leading-tight">Audience Authenticity</div>
            </div>
          </div>
          <div className="flex items-center gap-1">
            <div className="text-grey-5 text-base font-normal leading-normal">{data.audienceAuthenticity}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
